var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/vue-echarts/~/lodash/_Symbol.js
// module id = 678
// module chunks = 45